import React, { useContext, useState, useEffect } from 'react';
import { Container, Modal, Form, Row } from 'react-bootstrap';
import { Col, Button, Spinner } from 'react-bootstrap';
import $ from 'jquery';
import { apiRequest } from '../utils/apiHelper';
import { AppContext } from '../App';


export const Agents = () => {
    const { getLoad, setGetLoad, accessToken, link, setAccessToken, allAccounts, setAllAccounts, agents, setAgents } = useContext(AppContext);

    const [agentModal, setAgentModal] = useState(false);
    const [activeId, setActiveId] = useState();
    const saveAgent = (e) => {
        e.preventDefault();
        let name = e.target.name.value;
        let status = e.target.status.value;
        let account = e.target.account.value;
        let contact_details = e.target.contact_details.value;
        let terms = e.target.terms.value;
        if (name === "" || contact_details === "" || terms === "" || status === "") {
            alert("Please fill all fields");
            return;
        }
        apiRequest({
            url: `${link}api/cs/${activeId !== "" && activeId !== undefined ? "edit" : "add"}/agent/`,
            method: 'POST',
            data: {
                agent_id: activeId !== "" && activeId !== undefined ? activeId.substring(1) : "",
                name: name,
                status: status,
                account: account.substring(1),
                contact_details: contact_details,
                terms: terms
            },
            token: accessToken,
            setLoading: setGetLoad,
            setAccessToken: setAccessToken,
            onSuccess: (data) => {
                setAgents(prev => ({ ...prev, [data.id]: data.values }));
            }
        });
    }
    useEffect(() => {
        if (!agentModal) {
            setActiveId();
        }
    }, [agentModal]);
    const changeStatus = (status, id) => {
        if (status === "" || status === undefined || id === "" || id === undefined || id.substring(1) === "") {
            alert("Something went wrong");
            return;
        }
        apiRequest({
            url: `${link}api/cs/change/agent/status/`,
            method: 'POST',
            data: {
                status: status,
                id: id.substring(1)
            },
            token: accessToken,
            setLoading: setGetLoad,
            setAccessToken: setAccessToken,
            onSuccess: (data) => {
                setAgents(prev => ({ ...prev, [data.id]: data.values }));
            }
        });
    }
    const getAccountName = (id) => {
        if (id === "" || id === undefined || id === null || allAccounts === undefined || allAccounts.values === undefined || allAccounts.values[id] === undefined) {
            return "";
        }
        return `/ ${allAccounts.values[id].account_name}`;
    }
    return (
        <Container className="py-3">
            <Col xs={12} sm={12} md={12} lg={12} className='bdr2 br-3 mb-3' >
                <Col xs="12" sm="12" md="12" lg="12" className="staff-type-header bgs1 d-grid p-2 bdrb2" >
                    <span>{getLoad ? (<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>) : 'Agents.'}</span>
                    <Button onClick={() => { setAgentModal(true) }} className="btn-t1" ><i className="bi bi-plus-circle"></i> Add new</Button>

                </Col>
            </Col>
            {
                agents !== undefined && Object.keys(agents).length > 0 ? (
                    Object.keys(agents).map((item, i) => (
                        <Col xs="12" sm="12" md="12" lg="12" key={`agent-${i}`} className='bgs1 mb-1' >
                            <Row  >
                                <Col xs="12" sm="12" md="8" lg="8" >
                                    <div className="d-grid p-2 bdrb2" >
                                        <span>{agents[item].name} {getAccountName(agents[item].account)}</span>
                                        <span className="f12 ts1" >{agents[item].contact_details}</span>
                                        <span className="f12 ts2" >{agents[item].terms}</span>
                                    </div>
                                </Col>
                                <Col xs="12" sm="12" md="4" lg="4" className='d-flex align-items-center justify-content-end' >
                                    <div className='px-2 flex-wrap gap-1 align-items-center justify-content-end'>
                                        <Button onClick={() => {
                                            setAgentModal(true);
                                            setActiveId(item);
                                        }} variant='primary' >Edit</Button>
                                        {
                                            agents[item].status ? (
                                                <Button onClick={() => { changeStatus(false, item) }} variant='danger' >Disable</Button>
                                            ) : (
                                                <Button onClick={() => { changeStatus(true, item) }} variant='success' >Enable</Button>
                                            )
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    ))
                ) : ''
            }
            <Modal show={agentModal} onHide={() => { setAgentModal(false) }} size='lg' >
                <Modal.Header closeButton>
                    <Modal.Title>Add New Agent</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={saveAgent}>
                        <Form.Group controlId="formBasicName">
                            <Form.Label>Agent name</Form.Label>
                            <Form.Control type="text" name='name' defaultValue={activeId !== undefined ? agents[activeId].name : ''} placeholder="Enter name" />
                        </Form.Group>
                        <Form.Group controlId="formBasicAccount">
                            <Form.Label>Status</Form.Label>
                            <Form.Select name='status' defaultValue={activeId !== undefined ? agents[activeId].status : ''}>
                                <option value={true} >Enable</option>
                                <option value={false} >Disable</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formBasicAccount">
                            <Form.Label>Account</Form.Label>
                            <Form.Select name='account' defaultValue={activeId !== undefined ? agents[activeId].account : ''}>
                                <option value="" >Akshaya Account</option>
                                {
                                    allAccounts !== undefined && allAccounts.values !== undefined && Object.keys(allAccounts.values).length > 0 ? (
                                        Object.keys(allAccounts.values).map((item, i) => (
                                            <option key={`agent-${i}`} value={item}>{allAccounts.values[item].account_name}</option>
                                        ))
                                    ) : ''
                                }
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formBasicContactDetails">
                            <Form.Label>Contact Details</Form.Label>
                            <Form.Control type="text" name='contact_details' as='textarea' rows={4} defaultValue={activeId !== undefined ? agents[activeId].contact_details : ''} placeholder="Enter contact details" />
                        </Form.Group>
                        <Form.Group controlId="formBasicTermsAndConditions">
                            <Form.Label>Terms and Conditions</Form.Label>
                            <Form.Control type="text" name='terms' as='textarea' rows={4} defaultValue={activeId !== undefined ? agents[activeId].terms : ''} placeholder="Enter terms and conditions" />
                        </Form.Group>
                        <div className='d-grid py-2'>
                            <Button variant="success" type="submit">Submit</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </Container>
    )
}